// Shared with `screens.md` and `screens.lg` in tailwind.config.ts, so JS media queries match the `md:` and `lg:` classes.
export const MD_BREAKPOINT_PX = 768;

export const LG_BREAKPOINT_PX = 1024;

export const MEDIA_QUERY = {
    MD_UP: `(min-width: ${MD_BREAKPOINT_PX}px)`,
    REDUCED_MOTION: "(prefers-reduced-motion: reduce)",
    LG_UP: `(min-width: ${LG_BREAKPOINT_PX}px)`,
} as const;
